export default "__VITE_ASSET__DGCG5IXc__"